<template>
  <v-modal :name="modalName" :width="300" height="auto" :pivotY="0.1" :click-to-close="true" class="modal"
    @before-open="beforeOpen">
    <div class="text">
      <span v-if="noticeText">{{ noticeText }}</span>
      <div class="input-wrapper">
        <v-input class="input" :value="urlToShare" readonly />
      </div>
    </div>
    <div class="buttons">
      <button class="g-button" @click.prevent="$modal.hide(modalName)">
        {{ $t('CANCEL') }}
      </button>
      <button class="g-button g-button_primary" @click.prevent="copy">
        {{ $t('COPY') }}
      </button>
    </div>
  </v-modal>
</template>

<script>
import copyToClipboard from 'copy-text-to-clipboard';
import VModal from '@/components/VModal.vue';
import VInput from '@/components/VInput.vue';

export default {
  components: {
    VModal,
    VInput,
  },
  props: {
    notice: {
      type: String,
      default: ''
    },
    customUrl: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      modalName: 'sharePage',
      urlToShare: '',
      noticeText: '',
      styleElement: null
    };
  },
  computed: {
    href() {
      const url = new URL(this.$route.fullPath, location.origin);
      return url.toString();
    },
  },
  methods: {
    beforeOpen(event) {
      // Get parameters passed when opening the modal
      if (event.params) {
        this.urlToShare = event.params.customUrl || this.customUrl || this.href;
        this.noticeText = event.params.notice || this.notice;
      } else {
        this.urlToShare = this.customUrl || this.href;
        this.noticeText = this.notice;
      }

      // Inject global style before opening the modal
      this.injectModalStyle();
    },
    injectModalStyle() {
      // Remove any existing style element
      if (this.styleElement) {
        document.head.removeChild(this.styleElement);
      }

      // Create a new style element
      this.styleElement = document.createElement('style');
      this.styleElement.innerHTML = `
          .vm--modal[name="sharePage"] {
              background-color: var(--bg) !important;
              border: 2px solid var(--lighter-primary) !important;
              box-shadow: none !important;
              border-radius: 0 !important;
          }
      `;

      // Add it to document head
      document.head.appendChild(this.styleElement);
    },
    copy() {
      const urlToCopy = this.urlToShare;
      const isCopied = copyToClipboard(urlToCopy);
      if (isCopied) {
        this.$notify({
          type: 'success',
          text: this.$t('SHARE_LINK_COPIED'),
        });
        this.$modal.hide(this.modalName);
        return;
      }

      this.$notify({
        type: 'error',
        text: this.$t('SOMETHING_WENT_WRONG'),
      });
    },
  },
  beforeDestroy() {
    // Clean up style element when component is destroyed
    if (this.styleElement) {
      document.head.removeChild(this.styleElement);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/variables.scss";

.modal {
  &::v-deep {
    .vm--modal {
      background-color: var(--bg);
      border: 2px solid var(--lighter-primary);
    }

    .vm--overlay {
      background: rgba(0, 0, 0, var(--modal-overlay-opacity));
    }
  }
}

.text {
  padding: 15px 15px 10px;
  white-space: pre-line;
}

.input-wrapper {
  margin-top: 10px;
}

.buttons {
  display: flex;
  padding: 10px 15px 15px;
  border-top: 1px solid var(--tertiary-accent);

  button:last-child {
    margin-left: auto;
  }
}

.input {
  width: 100%;
}
</style>
